import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
// ... keep existing code ...
import { ThemeProvider, CssBaseline, StyledEngineProvider } from "@mui/material";
import gameshapeTheme from "./theme/index.js";

createRoot(document.getElementById("root")!).render(
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={gameshapeTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </StyledEngineProvider>
);